import type { CurrencyCode, SearchResultPriceFragment } from '#graphql-operations'

export function usePriceFormatter() {
  const { n: numberFormat } = useI18n()

  const formatCHF = (amount: number) => {
    const isWholeNumber = amount % 1 === 0
    const isNegative = amount < 0
    const absAmount = Math.abs(amount)

    const formatted = numberFormat(absAmount, 'currency', {
      currency: 'CHF',
      minimumFractionDigits: isWholeNumber ? 0 : 2,
      maximumFractionDigits: 2,
    })

    let result = formatted
    if (isWholeNumber)
      result = result.replace(/(\d+)(?:\.\d{2})?$/, '$1.-')

    if (isNegative)
      result = result.replace(/^-?\s*CHF\s*/, 'CHF -')

    return result
  }

  const lazyFormatter = useMemoize((amount: number, currencyCode: CurrencyCode) => {
    if (currencyCode === 'CHF') {
      return formatCHF(amount / 100)
    }

    return numberFormat(amount / 100, 'currency', { currency: currencyCode })
  })

  return (price: number | SearchResultPriceFragment | number = 0, currencyCode: CurrencyCode) => {
    if (typeof price === 'number')
      return lazyFormatter(price, currencyCode)

    if ('value' in price)
      return lazyFormatter(price.value, currencyCode)

    if ('min' in price && 'max' in price)
      return price.min === price.max ? lazyFormatter(price.min, currencyCode) : `${lazyFormatter(price.min, currencyCode)} - ${lazyFormatter(price.max, currencyCode)}`

    console.warn('Invalid price', price)
    return lazyFormatter(0, currencyCode)
  }
}
